import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "../components/styled/Elements";
import styled from "styled-components";
import NavSidebar from "../components/sidebar/NavSidebar";
import RightSidebar from "../components/sidebar/RightSidebar";
import UsersApi from "../services/api/usersApi";
import { useTranslation } from "react-i18next";
import AuthHeader from "../components/auth/AuthHeader/AuthHeader";

const VisitorLayout = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const getCities = async () => {
    try {
      const { data, code } = await UsersApi.getCitiesList();
      if (code === 200 && data?.length > 0) {
        const citiesData = data.map((city) => ({
          ...city,
          value: city?.id,
          label: language === "en" ? city?.name_en : city?.name_ar,
        }));
        localStorage.setItem("citiesList", JSON.stringify(citiesData));
      }
    } catch (error) {}
  };
  const getPlatform = async () => {
    try {
      const { data, code } = await UsersApi.getPlatform();
      if (code === 200 && data?.length > 0) {
        const platformData = data.map((platform) => ({
          ...platform,
          value: platform?.id,
          label: language === "en" ? platform?.en_name : platform?.ar_name,
        }));
        localStorage.setItem("platforms", JSON.stringify(platformData));
      }
    } catch (error) {}
  };
  useEffect(() => {
    getCities();
    getPlatform();
  }, [language]);
  return (
    <LayoutWrapper className="d-flex center-main">
      <AuthHeader />
      <Box className="flex-1 w-100">
        <Box className={"flex-1 custom-scroll content-main"}>
          <Box className="content-inner">
            <MainContent>
              <Outlet />
            </MainContent>
          </Box>
        </Box>
      </Box>
    </LayoutWrapper>
  );
};

export default VisitorLayout;

export const LayoutWrapper = styled.div`
  .content-main {
    padding: 88px 24px 4px 24px;
    .content-inner {
      display: flex;
      width: 100%;
      max-width: 1499px;
      margin-left: auto;
      margin-right: auto;
      height: 100%;
      gap: 16px;
      /* overflow: hidden; */
      padding-bottom: 20px;
    }
  }
  @media (max-width: 767px) {
    .content-main {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
`;
export const MainContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 190;
  /* background-color: var(--white); */
  border-radius: 10px;
  position: relative;
  /* box-shadow: 0px 0px 5px rgba(0, 0, 0, .1); */
`;
